import type React from 'react';
import { useTranslation } from 'react-i18next';
import { FaUserEdit as InvitedIcon } from 'react-icons/fa';

import { numberOrDash } from 'src/helper/helper';
import Column from 'src/components/dashboard/DashboardPage/components/Column/index';

export interface InvitedColumnProps {
  invited: number[];
}

const InvitedColumn: React.FC<InvitedColumnProps> = ({ invited }) => {
  const { t } = useTranslation('dashboard');

  return (
    <Column
      header={
        <>
          <InvitedIcon size={40} />
          {t('Labels.Invited')}
        </>
      }
      data={invited.map((invitations) => numberOrDash(invitations))}
    />
  );
};

export default InvitedColumn;
